export default "__VITE_ASSET__DVIdF09N__"